import { FaFacebook, FaTwitter, FaLinkedin, FaInstagram } from "react-icons/fa";
import { motion } from "framer-motion";

export default function Footer() {
    return (
        <footer className="bg-blue-900 text-white pt-12 pb-6 mt-20">
            <div className="container mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-12 text-right">

                {/* معلومات عامة */}
                <div>
                    <h3 className="text-xl font-bold mb-4">عن موبي كاشير</h3>
                    <p className="text-gray-300 text-sm leading-relaxed">
                        نظام كاشير ذكي وسحابي يساعدك على إدارة متجرك أو نشاطك التجاري بكفاءة وسهولة، مع تقارير لحظية ودعم فني متواصل.
                    </p>
                </div>

                {/* روابط سريعة */}
                <div>
                    <h3 className="text-xl font-bold mb-4">روابط مهمة</h3>
                    <ul className="space-y-2 text-sm">
                        <li><a href="#home" className="hover:text-yellow-400 transition">الرئيسية</a></li>
                        <li><a href="#features" className="hover:text-yellow-400 transition">المميزات</a></li>
                        <li><a href="#services" className="hover:text-yellow-400 transition">الخدمات</a></li>
                        <li><a href="#contact" className="hover:text-yellow-400 transition">اتصل بنا</a></li>
                    </ul>
                </div>

                 <div>
                    <h3 className="text-xl font-bold mb-4">تابعنا</h3>
                    <div className="flex justify-start md:justify-end space-x-4 rtl:space-x-reverse">
                        <motion.a whileHover={{ scale: 1.2 }} href="#" className="text-gray-300 hover:text-white"><FaFacebook /></motion.a>
                        <motion.a whileHover={{ scale: 1.2 }} href="#" className="text-gray-300 hover:text-white"><FaTwitter /></motion.a>
                        <motion.a whileHover={{ scale: 1.2 }} href="#" className="text-gray-300 hover:text-white"><FaInstagram /></motion.a>
                        <motion.a whileHover={{ scale: 1.2 }} href="#" className="text-gray-300 hover:text-white"><FaLinkedin /></motion.a>
                    </div>
                </div>
            </div>

            {/* خط سفلي */}
            <div className="mt-12 border-t border-gray-500 pt-4 text-center text-sm text-gray-200">
                جميع الحقوق محفوظة © {new Date().getFullYear()} موبي كاشير
            </div>
        </footer>
    );
}
